import { render, staticRenderFns } from "./InvoiceHistory.vue?vue&type=template&id=2afa5e22"
import script from "./InvoiceHistory.vue?vue&type=script&lang=js"
export * from "./InvoiceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports